import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartnerInfoDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-info-dto';

@Component({
    selector: 'app-partner-dialog',
    templateUrl: './partner-dialog.component.html',
    styleUrls: ['./partner-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: PartnerInfoDto) {}

  ngOnInit(): void {}
}
